import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { ChevronsUpDown } from "lucide-react";

export function SearchCombobox({ options, label, onSelect, placeholder = "Select…", searchPlaceholder = "Type to search…", emptyText = "No results.", testId = "search-combobox", triggerClassName = "mt-1.5 h-10" }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" role="combobox"
                className={`w-full justify-between font-normal text-left ${triggerClassName}`} data-testid={testId}>
          <span className={`truncate ${label ? "text-slate-800" : "text-slate-400"}`}>{label || placeholder}</span>
          <ChevronsUpDown size={13} className="opacity-50 shrink-0 ml-1" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[340px]" align="start">
        <Command>
          <CommandInput placeholder={searchPlaceholder} data-testid={`${testId}-search`} />
          <CommandList>
            <CommandEmpty>{emptyText}</CommandEmpty>
            {options.map((o) => (
              <CommandItem key={o.id} value={`${o.label} ${o.sub || ""}`} disabled={o.disabled}
                           onSelect={() => { onSelect(o.id); setOpen(false); }}
                           data-testid={`${testId}-opt-${o.id}`}>
                <span className="truncate">{o.label}</span>
                {o.sub && <span className="ml-auto pl-2 text-[10px] text-slate-400 shrink-0">{o.sub}</span>}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
